import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api.js";
import { ErrorBox, fmtDate } from "../components/helpers.jsx";

export default function BanDetail() {
    const { id } = useParams();
    const [row, setRow] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get(`/api/admin/bans/${id}`)
            .then((d) => { if (alive) setRow(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [id]);

    let flags = null, identifiers = null, telemetry = null;
    if (row?.flagsJson)       try { flags       = JSON.parse(row.flagsJson); }       catch { /* */ }
    if (row?.identifiersJson) try { identifiers = JSON.parse(row.identifiersJson); } catch { /* */ }
    if (row?.telemetryJson)   try { telemetry   = JSON.parse(row.telemetryJson); }   catch { /* */ }

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Ban #{id}</h1>
                    <div className="sub"><Link to="/bans">← all bans</Link></div>
                </div>
                {row && <span className={`pill ${row.active ? "active" : "lifted"}`}>{row.active ? "active" : "lifted"}</span>}
            </div>

            <ErrorBox>{err}</ErrorBox>

            {row && (
                <>
                    <div className="card">
                        <h2>Summary</h2>
                        <table className="data">
                            <tbody>
                                <tr><th>Subject</th><td>
                                    {row.subjectLabel && (
                                        <div style={{ fontWeight: 500 }}>{row.subjectLabel}</div>
                                    )}
                                    <div className="mono text-dim">{row.subject}</div>
                                </td></tr>
                                <tr><th>HWID</th><td className="mono">{row.hwid ?? "—"}</td></tr>
                                <tr><th>Category</th><td>{row.category ?? "—"}</td></tr>
                                <tr><th>Reason</th><td>{row.reason}</td></tr>
                                <tr><th>IP</th><td className="mono">{row.ip ?? "—"}</td></tr>
                                <tr><th>Source</th><td>{row.source}</td></tr>
                                <tr><th>Banned at</th><td>{fmtDate(row.createdAt)}</td></tr>
                                {row.liftedAt && (
                                    <>
                                        <tr><th>Lifted at</th><td>{fmtDate(row.liftedAt)}</td></tr>
                                        <tr><th>Lifted by</th><td>{row.liftedBy}</td></tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {flags && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Flags at ban time</h2>
                            <div className="flag-list">
                                {flags.map((f, i) => (
                                    <div key={i} className={`flag sev-${f.severity}`}>
                                        <div className="cat">{f.category}</div>
                                        <div className="reason">{f.reason}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {identifiers && identifiers.length > 0 && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Identifiers cascaded to HWID bans ({identifiers.length})</h2>
                            <table className="data">
                                <thead><tr><th>Kind</th><th>Value</th><th>Source</th></tr></thead>
                                <tbody>
                                    {identifiers.map((id, i) => (
                                        <tr key={i}>
                                            <td>{id.kind}</td>
                                            <td className="mono">{id.value}</td>
                                            <td className="text-dim">{id.source ?? "user"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {row.screenshotPath && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Screenshot at ban time</h2>
                            <a
                                href={`/api/admin/bans/${id}/screenshot`}
                                target="_blank"
                                rel="noreferrer"
                                title="Open full-size in a new tab"
                            >
                                <img
                                    src={`/api/admin/bans/${id}/screenshot`}
                                    alt={`Screenshot at ban time for ban #${id}`}
                                    style={{ maxWidth: "100%", border: "1px solid var(--border)", borderRadius: 4 }}
                                />
                            </a>
                        </div>
                    )}

                    {telemetry && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Telemetry snapshot</h2>
                            <pre className="json-block">{JSON.stringify(telemetry, null, 2)}</pre>
                        </div>
                    )}
                </>
            )}
        </>
    );
}
